// CHS dev environment (ECS Fargate in gp-dev AWS account).
// The Plone backend URL is injected at container runtime through ECS task vars.
import { DEFAULT_WHITELIST_PROMPT } from './enhancedSearchDefaults';

export const environment = {
  envType: 'chs-dev',
  voyager: {
    baseUrl: 'https://ogc-sdi.voyagersearch.com',
    solrSelectUrl: 'https://ogc-sdi.voyagersearch.com/solr/v0/select',
    configId: 'default',
    displayId: 'D187992491DF',
    searchUrl: 'https://ogc-sdi.voyagersearch.com/navigo/search',
    detailsUrl: 'https://ogc-sdi.voyagersearch.com/navigo/show',
  },
  maps: {
    leafletMarkerIconBaseUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images',
    arcgisWorldTopoUrl:
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
    openStreetMapTileUrl: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    cartoTileUrl:
      'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
  },
  enhancedSearch: {
    apiBaseUrl: 'https://jcplblcxg9.execute-api.us-east-1.amazonaws.com',
    feedbackApiUrl:
      'https://7u0cumuy79.execute-api.us-east-1.amazonaws.com/score',
    whitelistPrompt: DEFAULT_WHITELIST_PROMPT,
  },
};
